<ng-container [formGroup]="formCtrl">
  <div class="form-container">
    <div class="form-group !items-end">
      <div class="form-control grow">
        <label class="field-label bd-field-label required">Action name</label>
        <input class="bd-text-input tall" formControlName="name" required />
      </div>
      @if (showSetRootNodeBtn) {
        <div class="form-control ml-8">
          <button type="button" class="script-btn" blazeButton (click)="setRootNode()">
            <mat-icon svgIcon="icon_script_24" />
            <div class="text">
              Edit Root Node
              <span class="data"> <mat-icon svgIcon="icon_direction_right_24" /> DATA </span>
            </div>
          </button>
        </div>
      }
      @if (showResponseSchema) {
        <div class="form-control ml-8">
          <button type="button" class="script-btn" blazeButton (click)="onShowResponseSchema()">
            <mat-icon svgIcon="icon_script_24" />
            <div class="text">
              {{ isResponseSchemaCached ? 'Cached' : 'Fetched: just now' }}<br />
              VIEW SCHEMA
            </div>
          </button>
        </div>
      }
      <div class="form-control ml-8 test">
        <blaze-test-action-btn
          (confirmClick)="confirmAction()"
          (testClick)="testAction()"
          [action]="action"
          [showValidation]="showValidation"
          [valid]="formCtrl.valid"
        />
      </div>
      <div class="form-control actions">
        @if (canDeleteAction) {
          <button blazeIconButton type="button" (click)="deleteAction()">
            <mat-icon svgIcon="icon_trash_16" />
          </button>
        }
        <button
          (click)="expandCard()"
          [blazeIconButtonActive]="true"
          blazeIconButton
          class="expand-btn"
          color="accent"
          type="button"
        >
          <mat-icon [svgIcon]="action.expanded ? 'icon_chevron_up_16' : 'icon_chevron_down_16'" />
        </button>
      </div>
    </div>
  </div>

  <mat-expansion-panel [expanded]="action.expanded">
    <div class="form-container mt-16">
      <div class="form-group nested">
        <div class="form-control column-limited method">
          <label class="field-label bd-field-label">Action Type</label>
          <blaze-select
            [allowNone]="false"
            [options]="possibleMethods"
            [showNoneOption]="false"
            [showSelection]="true"
            class="tall uppercase bg-base-white"
            formControlName="httpMethod"
            selectClass="rest-api-methods"
          />
        </div>
        <div class="form-control column-extended url">
          <label class="field-label bd-field-label">URL</label>
          <div class="bd-input-with-suffix">
            <input
              class="bd-text-input tall w-full"
              formControlName="url"
              placeholder="Example: /orders"
            />
            <mat-icon
              blazeTooltip="Include path parametrs here eg.&nbsp;/orders/{order_id}. Define URL query parameters or Headers below."
              class="bd-input-suffix"
              matTooltipClass="api-builder-tooltip"
              matTooltipPosition="above"
              svgIcon="icon_info_16"
            />
          </div>
        </div>
      </div>
      @if (showBodyCtrl) {
        <div class="form-group nested mt-16">
          <div class="form-control column-limited body-type">
            <label class="field-label bd-field-label">
              Body
              <mat-icon
                blazeTooltip="Dynamic: Build the request body within the API Node in your workflow"
                class="align-bottom !text-primary-lighter"
                matTooltipClass="api-builder-tooltip"
                matTooltipPosition="above"
                svgIcon="icon_info_16"
              />
            </label>
            <mat-button-toggle-group
              [formControl]="bodyTypeCtrl"
              class="button-group-input stretch"
            >
              <mat-button-toggle [value]="BodyType.Predefined">Predefined</mat-button-toggle>
              <mat-button-toggle [value]="BodyType.Dynamic">Dynamic</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
          <div class="form-control column-extended edit-body">
            @switch (bodyTypeCtrl.value) {
              @case (BodyType.Dynamic) {
                <input
                  class="bd-text-input tall readonly-input hint"
                  disabled
                  value="Build the request body within the API Node in your workflow"
                />
              }
              @case (BodyType.Predefined) {
                <button blazeButton type="button" class="script-btn" (click)="editBody()">
                  <mat-icon svgIcon="icon_script_24" />
                  <span class="data uppercase ml-8">{{ action.data.httpMethod }} body</span>
                  <span class="text-primary px-8 ml-auto">
                    {{ bodyParametersLength }} Parameters
                  </span>
                </button>
              }
            }
          </div>
        </div>
      }
      <div class="form-group nested mt-16">
        <div class="form-control column-limited success-status-code">
          <label class="field-label bd-field-label">Success Status Code</label>
          <input formControlName="successStatusCode" class="bd-text-input tall" />
        </div>
        <div class="form-control column-extended error-result-path">
          <label class="field-label bd-field-label">Error Result Path</label>
          <input formControlName="errorResultPath" class="bd-text-input tall" />
        </div>
      </div>
    </div>

    <div class="form-container">
      <div class="form-group mt-16">
        <div class="form-control">
          <mat-slide-toggle disableRipple class="bd-toggle" formControlName="useCookies">
            Send cookies with request
          </mat-slide-toggle>
        </div>
      </div>
    </div>

    <blaze-parameters-list-extended
      [formCtrl]="urlParametersCtrl"
      [parameters]="action.data.urlParameters"
      label="URL Parameters"
    />

    <blaze-parameters-list-extended
      [formCtrl]="headersCtrl"
      [parameters]="action.data.headers"
      label="Headers"
    />
  </mat-expansion-panel>
</ng-container>
